import { STATES } from '../../../../../constants';
import { isFeatureEnabled } from '@updater-core/lib/optimizely';

export function ForwardMailListConfig($stateProvider) {
  'ngInject';

  $stateProvider.state(STATES.STEP_FORWARD_MAIL_LIST, {
    url: '',
    views: {
      '@': {
        template: async () => {
          const isInRedesignTest = await isFeatureEnabled('fym_reskin');
          return isInRedesignTest
            ? '<uds-forward-mail-list class="uds"></uds-forward-mail-list>'
            : '<upd-forward-mail-list></upd-forward-mail-list>';
        },
      },
    },
    params: {
      // Pass in `verified` in the $stateParams to show success message
      verified: undefined,
    },
    title: 'Forward Your Mail',
    scrollTop: true,
    reloadOnSearch: false,
    // Ignore breadcrumb - parent title is used instead
    ignore: true,
    titleBar: {
      title: 'Forward Your Mail',
      save: 'Average Time Saved: 20 minutes',
      icon: 'mail',
    },
    disableBreadcrumb: true,
    data: {
      permissions: 'signedIn && !military && !needToVerify && hasFyms',
      militaryState: STATES.STEP_FORWARD_MAIL_MILITARY,
      verifyState: STATES.STEP_FORWARD_MAIL_VERIFY,
    },
    analytics: {
      page: 'Forward Mail',
    },
  });
}
